export const getMainEmail = (emailData) => {
  const primaryTrueValuesFirstComparer = (a, b) => b.Primary - a.Primary;
  return emailData.Emails.sort(primaryTrueValuesFirstComparer)[0];
};
